module.exports = __webpack_public_path__ + "img/zablokuj_zlecenie.c825dc9d.svg";